import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useParams, useHistory, Link } from 'react-router-dom';
import moment from 'moment';
import Swal from 'sweetalert2';
import Select from 'react-select';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import useUserStore from '../../stores/Users';
import LoadingView from '../../components/Loading';
import Icon from '../../components/Icon';
import Card from '../../components/SimpleCard';
import axios from 'axios';
import { baseAPI } from '../../services/baseAPI';

function EditPinjamanTunai() {
  const { id, iduser } = useParams();
  const history = useHistory();
  const USP = 3;
  const BENDAHARA = 5;
  const token = useUserStore((state) => state.token);
  const user = useUserStore((state) => state.user);

  const [isLoading, setIsLoading] = useState(true);
  const [listBesarPlafond, setListBesarPlafond] = useState([
    { label: "Rp.1.000.000", value: 1000000 },
    { label: "Rp.2.000.000", value: 2000000 },
    { label: "Rp.3.000.000", value: 3000000 },
    { label: "Rp.4.000.000", value: 4000000 },
    { label: "Rp.5.000.000", value: 5000000 },
    { label: "Rp.6.000.000", value: 6000000 },
    { label: "Rp.7.000.000", value: 7000000 },
    { label: "Rp.8.000.000", value: 8000000 },
    { label: "Rp.9.000.000", value: 9000000 },
    { label: "Rp.10.000.000", value: 10000000 },
    { label: "Rp.11.000.000", value: 11000000 },
    { label: "Rp.12.000.000", value: 12000000 },
    { label: "Rp.13.000.000", value: 13000000 },
    { label: "Rp.14.000.000", value: 14000000 },
    { label: "Rp.15.000.000", value: 15000000 },
  ]);
  const [listLamaCicilan, setListLamaCicilan] = useState([
    { label: "3 - Bulan", value: 3 },
    { label: "6 - Bulan", value: 6 },
    { label: "9 - Bulan", value: 9 },
    { label: "12 - Bulan", value: 12 },
    { label: "18 - Bulan", value: 18 },
    { label: "24 - Bulan", value: 24 },
  ])
  const [empBesarPlafond, setEmpBesarPlafond] = useState([]);
  const [empLamaCicilan, setEmpLamaCicilan] = useState(0);
  const [empSetorPlafond, setEmpSetorPlafond] = useState([]);
  const [empSetorTotal, setEmpSetorTotal] = useState([]);
  const [empJrate, setEmpJRate] = useState([]);
  const [empData, setEmpData] = useState([]);
  const [jrateData, setJRateData] = useState([]);
  const [ajuanData, setAjuanData] = useState([]);
  const [newData, setNewData] = useState({
    plafond: "",
    lama:0,
    cpokok: "",
    cicilan: "",
    jasa_bulan: "",
    trxdetailpinjam: "",
    created_at: "",
    status: "",
  });


  // CONTROLLER

  const fetchData = async (id_user, id) => {
    setIsLoading(true);

      await axios
      .all(
        [
        baseAPI .get(`/v1/user/${id_user}`, { headers: { Authorization: `Bearer ${token}` } }),
        baseAPI .get(`/v1/jrate`, { headers: { Authorization: `Bearer ${token}` } }),
        baseAPI .get(`/v1/ajuanpinjam/${id}`, { headers: { Authorization: `Bearer ${token}` } }),
        ]
      )
      .then((res) => {
        const dataUser = res[0].data.data.userData;     
        const dataJrate = res[1].data.data.jrate;       
        const dataAjuan = res[2].data.data.ajuanpinjam;
        
        let besarPlafond = []
        listBesarPlafond.map(e => {
          if(e.value == dataAjuan[0].plafond) {
            besarPlafond.push({ label: e.label, value: e.value })
          }
        });

        let lamaCicil = []
        listLamaCicilan.map(e => {
          if(e.value == dataAjuan[0].lama) {
            lamaCicil.push({ label: e.label, value: e.value })
          }
        });

        setEmpJRate("Rp." + parseFloat(dataAjuan[0].jasa_bulan).toLocaleString('id-ID'));
        setEmpSetorPlafond("Rp." + parseFloat(dataAjuan[0].cpokok).toFixed().toLocaleString('id-ID'))
        setEmpSetorTotal("Rp." + parseFloat(dataAjuan[0].cpokok + dataAjuan[0].jasa_bulan).toLocaleString('id-ID'));
        setEmpBesarPlafond(besarPlafond[0]);
        setEmpLamaCicilan(lamaCicil[0]);
        setEmpData(dataUser[0]);
        setAjuanData(dataAjuan[0]);
        setJRateData(dataJrate);
        setNewData({...newData,
          plafond: dataAjuan[0].plafond,
          status: dataAjuan[0].status,
          lama: dataAjuan[0].lama,
          cpokok: dataAjuan[0].cpokok,
          cicilan: dataAjuan[0].cpokok + dataAjuan[0].jasa_bulan,
          jasa_bulan: dataAjuan[0].jasa_bulan,
          trxdetailpinjam: dataAjuan[0].trxdetailpinjam,
          created_at: dataAjuan[0].created_at,
          cicilan_ke: dataAjuan[0].cicilan_ke,
          npp_anggota: dataAjuan[0].npp_anggota,
          notrxdetailpinjam: dataAjuan[0].notrxdetailpinjam,
          id_users: dataAjuan[0].id_users,
        })
      })
      .catch((error) => {
        setIsLoading(false);
        Swal.fire({
          icon: 'error',
          title: `Gagal mengambil data`,
          showConfirmButton: false,
          timer: 1500
        })
        console.log(`error ${error}`);
      })
      .finally(() => {
        setIsLoading(false);
      })
  };

  const updatePinjaman = async (id, idUser, status) => {

    Swal.fire({
      title: 'Apakah anda akan ' + status + ' pinjaman ini?',
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: 'Ya',
    }).then((result) => {
      if (result.isConfirmed) {
        setIsLoading(true);

        const body = new FormData();
        body.append('update_data', JSON.stringify(newData));
        body.append('status', status === "melunasi" ? "Lunas" : "Update");

        baseAPI
          .put(`/v1/detailpinjam/${id}/${idUser}`, body, {
            headers: {
              Accept: 'application/json',
              Authorization: `Bearer ${token}`,
              'Content-Type': 'multipart/form-data',
            },
          })
          .then((res) => {
            Swal.fire({
              icon: 'success',
              title: "Data pengajuan pinjaman berhasil diperbarui.",
              showConfirmButton: false,
              timer: 1500
            })
            fetchData(idUser, id);
            console.log(`berhasil upload ${JSON.stringify(res)}`);
          })
          .catch((error) => {
            setIsLoading(false);
            console.log('error: ', error);
            Swal.fire({
              icon: 'error',
              title: "Data pengajuan pinjaman gagal diperbarui.",
              showConfirmButton: false,
              timer: 1500
            })
          })
          .finally(() => {
            setIsLoading(false);
            fetchData(idUser, id);
          })
      }
    });

  }

  const checkCicilanPlafond = async (lama, plafond) => {
  
    if (lama !== 0) {
      let cpokok = 0;
      let cicilan = 0;
      let rupiahCpokok = 0;
      let rupiahJasa = 0;
      let rupiahCicilan = 0;
  
      let matchedRate = null;
  
      // Find the matching rate
      jrateData.some(e => {
        if (e.plafond === plafond && e.tenor === lama) {
          matchedRate = e;
          return true; // Stop iterating after the first match
        }
        return false;
      });
  
      if (matchedRate) {
        cpokok = (plafond / lama).toFixed(0);
        cicilan = (matchedRate.jasa_bulan + (plafond / lama)).toFixed(0);
  
        rupiahCpokok = parseFloat(cpokok).toLocaleString('id-ID');
        rupiahJasa = parseFloat(matchedRate.jasa_bulan).toLocaleString('id-ID');
        rupiahCicilan = parseFloat(cicilan).toLocaleString('id-ID');
  
        // Use the functional form of setNewData to ensure you're working with the latest state
        setNewData(prevData => ({
          ...prevData,
          jasa_bulan: matchedRate.jasa_bulan,
          cicilan: cicilan,
          cpokok: cpokok,
        }));

        setEmpSetorPlafond("Rp." + rupiahCpokok);
        setEmpJRate("Rp." + rupiahJasa);
        setEmpSetorTotal("Rp." + rupiahCicilan);
      }
    }
  };
  
  
  useEffect(() => {
    if (user.role === USP || user.role === BENDAHARA) {
      fetchData(iduser, id);
    };
  }, [token]);

  // VIEW

  const headerView = () => (
    <div className='page-header'>
      <div className='row align-items-center'>
        {/* Title */}
        <div className='col'>
          <ol className='breadcrumb'>
            <li className='breadcrumb-item Navbar_title'>
              <Link to='#' style={{ color: '#333' }}>Pinjaman Tunai</Link> /{' '}
              <Link to='/pinjamtunai/datapinjamantunai' style={{ color: '#333' }}>Data Pinjaman Tunai</Link> /{' '}
              <Link to='#' style={{ color: '#333' }}>Edit Pinjaman Tunai</Link>
            </li>
          </ol>
        </div>
      </div>
    </div>
  );

  const parsedDate = moment(newData.created_at, "YYYY-MM-DD HH:mm:ss");
  const defaultDate = parsedDate.isValid() ? parsedDate.toDate() : null;
  const parseAppDate = moment(newData.trxdetailpinjam, "YYYY-MM-DD HH:mm:ss");
  const apprDate = parseAppDate.isValid() ? parseAppDate.toDate() : null;

  const addView = () => (
    <div className='row row-deck row-cards'>
      <div className='col-md-12'>
        <div className='card'>
          <div className='card-body'>
            <div className='row'>
              <div className='mb-3'>
                <p style={{fontSize: 25}}><b>Edit Pinjaman Tunai</b></p>
                <p>Silahkan update pinjaman tunai berikut.</p>
              </div>
              
              {/* Besar plafond */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Besar Plafond
                </label>
                <Select
                  options={listBesarPlafond}
                  value={listBesarPlafond && empBesarPlafond}
                  isDisabled={ajuanData.cicilan_ke != 0 ? true : false}
                  placeholder="Pilih besar plafond"
                  onChange={e => {
                    setEmpBesarPlafond(e);
                    setNewData(prevData => ({ ...prevData, plafond: e.value }));
                    checkCicilanPlafond(newData.lama, e.value);
                  }}
                />
              </div>

              {/* Lama cicilan plafond */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Lama Cicilan
                </label>
                <Select
                  isDisabled={ajuanData.cicilan_ke == 0 ? (newData.plafond !== "" ? false : true) : true}
                  options={listLamaCicilan}
                  value={listLamaCicilan && empLamaCicilan}
                  placeholder="Pilih item"
                  onChange={e => {
                    setEmpLamaCicilan(e);
                    setNewData(prevData => ({ ...prevData, lama: e.value }));
                    checkCicilanPlafond(e.value, empBesarPlafond.value);
                  }}
                />
              </div>

              {/* Tanggal pengajuan */}
              <div className='col-md-3 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Tanggal Pengajuan
                </label>
                <DatePicker
                  readOnly
                  selected={defaultDate}
                  placeholderText="Pilih tanggal"
                  className="form-control datepicker"
                  dateFormat="dd/MM/yyyy"
                  // onChange={(date) => {
                  //   console.log("Selected Date:", date); // Add this line for debugging
                  //   setNewData({...newData, trxdetailpinjam: date });
                  // }}
                />
              </div>

              {/* Tanggal approved */}
              <div className='col-md-3 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Tanggal Approved
                </label>
                <DatePicker
                  readOnly
                  selected={newData.status === "Diajukan" || newData.status === "Disetujui USP" || newData.status === "Ditolak" ? null : apprDate}
                  placeholderText="-- menunggu approved --"
                  className="form-control datepicker"
                  dateFormat="dd/MM/yyyy"
                  // onChange={(date) => {
                  //   console.log("Selected Date:", date); // Add this line for debugging
                  //   setNewData({...newData, trxdetailpinjam: date });
                  // }}
                />
              </div>

              {/* Name */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Name
                </label>
                <input
                  defaultValue={empData.name_anggota}
                  placeholder='Employee name'
                  className="form-control"
                  readOnly
                />
              </div>

              {/* Besar jasa per bulan */}
              <div className='col-md-4 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Besar Jasa per Bulan
                </label>
                <input
                  value={empJrate}
                  placeholder='Besar jasa bulan'
                  className="form-control"
                  readOnly
                />
              </div>

              {/* Cicilan Pokok per bulan */}
              <div className='col-md-4 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Cicilan Pokok per bulan
                </label>
                <input
                  value={empSetorPlafond}
                  placeholder='Cicilan pokok per bulan'
                  className="form-control"
                  readOnly
                />
              </div>

              {/* Cicilan Total (jasa + pokok) per bulan */}
              <div className='col-md-4 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Cicilan Total per bulan
                </label>
                <input
                  value={empSetorTotal}
                  placeholder='Cicilan Total per bulan'
                  className="form-control"
                  readOnly
                />
              </div>

              <div className={user.role === USP ? "col-md-6" : "col-md-12"}>
                <button
                  disabled={newData.status === "Disetujui USP" || newData.status === "Diajukan" ? (newData.lama !== 0 && newData.plafond !== "" && newData.cpokok !== "" && newData.jasa_bulan !== "" && newData.status !== "Lunas" ? false : true) : true}
                  type="button"
                  className='btn btn-danger col-md-12'
                  style={{backgroundColor: "#6A9C89"}}
                  onClick={() => {
                    setNewData({...newData, status: "Update"})
                    updatePinjaman(ajuanData.id, iduser, "memperbarui")
                  }}
                >
                  Update
                </button>
              </div>
              
              {user.role === USP 
              ? 
                <div className='col-md-6'>
                  <button
                    disabled={newData.status !== "Lunas" ? false : true}
                    type="button"
                    className='btn btn-danger col-md-12'
                    onClick={() => {
                      setNewData({...newData, status: "Lunas"})
                      updatePinjaman(ajuanData.id, iduser, "melunasi")
                    }}
                  >
                    Ajukan Pelunasan
                  </button>
                </div>
              : <></>}

            </div>
          </div>
        </div>
      </div>

    </div>
  )

  return (
    <div className='container-fluid'>
      
      {headerView()}
      
      {isLoading ? <LoadingView /> : addView()}
      {/* {addView()} */}

    </div>
  );

}

export default EditPinjamanTunai;